<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Laporan Tunggakan Hasil">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                      <z-lookup 
                            label="Bulan"
                            url="bulanlookupstatic"
                            :sort="false" :cache="false" v-model="cari.bulan" />
                        <z-lookup v-if="show_jabatan == true"
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user2'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <!-- <w-input 
                            v-model="cari.tahun"
                            type="number"
                            label="Tahun"
                        /> -->
                        <z-lookup 
                        label="Tahun"
                        name="tahun"
                        url="admin.yearlookup"
                        :sort="false"
                        :cache="false"
                        
                        v-model="cari.tahun"
                        />
                    </div>
                    
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="janaDialog()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Jana
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>TEMPOH TUNGGAKAN </td>
                                <td>CUKAI TANAH (RM)</td>
                                <td>TUNGGAKAN CUKAI TANAH (RM)</td>
                                <td>CUKAI PETAK (RM)</td>
                                <td>TUNGGAKAN CUKAI PETAK (RM)</td>
                                <td>CUKAI TALI AIR (RM)</td>
                                <td>TUNGGAKAN CUKAI TALI AIR (RM)</td>
                                <td>DENDA (RM)</td>
                                <td>TUNGGAKAN DENDA (RM)</td>
                                <td>NOTIS (RM)</td>
                                <td>TUNGGAKAN NOTIS (RM)</td>
                                <td>JUMLAH (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.datas && table.datas.length > 0">
                                <tr v-for="(dt, index) in table.datas">
                                    <template v-if="dt.keterangan == 'JUMLAH'">
                                        <td><b>{{ dt.keterangan }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.cukai_tanah }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.tunggakan_cukai_tanah }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.cukai_petak }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.tunggakan_cukai_petak }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.cukai_tali_air }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.tunggakan_cukai_tali_air }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.denda }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.tunggakan_denda }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.notis }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.tunggakan_notis }}</b></td>
                                        <td style="text-align: right"><b>{{ dt.jumlah }}</b></td>
                                    </template>
                                    <template v-else>
                                        <!-- <a v-if="dt.type && dt.jumlah != '0.00'" :href="service_kutipan+'kutipan/laporan/cukai_akaun_belum_terima_senarai'+'?type='+dt.type + '&bulan=' + cari.bulan +'&jabatan_id='+cari.jabatan_id+'&tahun=' +cari.tahun + '&user_id=' + auth.user.id + '&cetak=1'+'&pdf=1&nama_fail='+cari.tahun+'-'+dt.type+'-'+ auth.user.id+'-laporan_tunggakan.pdf'" :download="cari.tahun+'-'+dt.type+'-'+ auth.user.id+'laporan_tunggakan.pdf'">
                                            {{ dt.keterangan }}
                                        </a> -->
                                        <a v-if="dt.type && dt.jumlah != '0.00'" @click="checkSenarai(dt)" href="#">
                                            {{ dt.keterangan }}
                                        </a>
                                        <span v-else>
                                            {{ dt.keterangan }}
                                        </span>
                                        <td style="text-align: right">{{ dt.cukai_tanah }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_tanah }}</td>
                                        <td style="text-align: right">{{ dt.cukai_petak }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_petak }}</td>
                                        <td style="text-align: right">{{ dt.cukai_tali_air }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_cukai_tali_air }}</td>
                                        <td style="text-align: right">{{ dt.denda }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_denda }}</td>
                                        <td style="text-align: right">{{ dt.notis }}</td>
                                        <td style="text-align: right">{{ dt.tunggakan_notis }}</td>
                                        <td style="text-align: right"><b>{{ dt.jumlah }}</b></td>
                                    </template>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="10" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </w-flex>
            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
            <w-dialog
                v-model="dialog.show"
                title="Sila pilih janaan Anda"
                persistent
                :width="550">

                <template #actions>
                    <div class="spacer" />
                    <w-button
                    class="mr2"
                    @click="janaDb()"
                    :loading="readingfile"
                    bg-color="error">
                    Janaan Pertama
                    </w-button>
                    <w-button
                    @click="janaCache()"
                    bg-color="success">
                    Jana Semula
                    </w-button>&nbsp;&nbsp;
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                </template>
                </w-dialog>

            <w-dialog
                v-model="dialogsenarai.show"
                title="Data Senarai"
                persistent
                :width="550">
                    Penjanaan data senarai dalam proses...
                <template #actions>
                    <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialogsenarai.show = false">Tutup</w-button>
                </template>
            </w-dialog>


        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
    show_jabatan: [Array, Object, String],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/dummy',
        reload: true,
        loading: false,
        readingfile: false,
        disabled: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        dialog: {
            show: false,
        },
        dialogsenarai: {
            show: false,
        },
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Tunggakan Hasil', route: '/tunggakanhasil' },
            { label: 'Laporan Tunggakan Hasil', route: '/tunggakanhasil/laporan' },
          ],
          cari : {bulan: '', tahun: '', jabatan_id: ''},
          cache: true,
          }
  },
  methods: {

    search() {
        this.getDataQuery();
    //   this.$inertia.visit(window.route('tunggakanhasil.tunggakanhasil')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },
    janaDialog(){
        this.readingfile = false;
        this.disabled = false;
        // axios.get(
        //     this.service_laporan + "kutipan/laporan/check_file_cache?user_id=" + this.auth.user.id +
        //         "&bulan=" + this.cari.bulan +
        //         "&tahun=" + this.cari.tahun +
        //         "&jabatan_id=" + this.cari.jabatan_id
                
        // ).then((e)=>{
        //     if(e.data){
        //         // console.log('found!')
        //         this.disabled = true;
        //     } else {
        //         // console.log('not found!')
        //         this.disabled = false;
        //     }
        //     this.readingfile = false;
        // })
        this.dialog.show = true
    },
    janaDb(){
        this.dialog.show = false
        this.cache = false
        this.$refs.dform.validate()
    },
    janaCache(){
        this.dialog.show = false
        this.cache = true
        this.$refs.dform.validate()
    },
    checkSenarai(dt){
        this.loading = true
        var url = this.$route('tunggakan_hasil.senarai_tunggakan')+'?type='+dt.type 
        + '&bulan=' + this.cari.bulan 
        +'&jabatan_id='+this.cari.jabatan_id
        +'&tahun=' +this.cari.tahun 
        + '&user_id=' + this.auth.user.id 
        + '&title='+dt.keterangan+ '&static=true' +'&par='+dt.par;
        axios.get(
            this.service_laporan + "kutipan/laporan/check_file_cache?user_id=" + this.auth.user.id +
                "&bulan=" + this.cari.bulan +
                "&tahun=" + this.cari.tahun +
                "&jabatan_id=" + this.cari.jabatan_id +
                '&senarai='+dt.type
                
        ).then((e)=>{
            if(e.data){
                // console.log('found!')
                window.location.href = url;
            } else {
                // console.log('not found!')
                this.dialogsenarai.show = true
            }
            this.loading = false
        })

    },
    reset(){
      this.cari = {bulan: '', tahun: '', jabatan_id: ''}
      this.search()
    },

    cetak() {
        window.open(this.service_laporan+'kutipan/laporan/cukai_akaun_belum_terima?cetak=1&user_id='+
        this.auth.user.id+'&bulan='+this.cari.bulan+'&tahun='+this.cari.tahun +"&jabatan_id=" + this.cari.jabatan_id + '&static=true' + '&cache=' + this.cache,'_blank');
    },
    async getDataQuery() {
        this.loading = true;
        var cari_type = '';
        if(this.cari.type)
            cari_type = "&type=" + this.cari.type;
        const resp = await axios.get(
            this.service_laporan + "kutipan/laporan/cukai_akaun_belum_terima?user_id=" + this.auth.user.id +
                "&bulan=" + this.cari.bulan +
                "&tahun=" + this.cari.tahun + cari_type +
                "&jabatan_id=" + this.cari.jabatan_id + '&static=true' + '&cache=' + this.cache
                
        );
        this.table = resp.data;
        this.loading = false;
    },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.bulan == 'undefined'){this.cari.bulan = ''}
    if(this.cari.tahun == 'undefined'){this.cari.tahun = ''}
    if(this.cari.jabatan_id == 'undefined'){this.cari.jabatan_id = ''}
    if(this.cari.type){
        this.getDataQuery()
    }
    // console.log(this.auth.user);
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>